import i18next from 'i18next'
import React from 'react'
import { ExternalLink } from '../../utils/externalLink'
import { MembershipCaclulatorState } from './membershipCaclulatorState'
import { calculatorText, employeeCount } from './membershipCalculatorUtils'
import { Link } from '../../utils/links'

export type MembershipCaclulatorProps = {
  state: MembershipCaclulatorState
  // setOrganizationConcerns: (concern: string, checked: boolean) => void
  setEmployeeCount: (countOption: string) => void
}

export const MembershipCaclulatorLayout = (
  props: MembershipCaclulatorProps
) => {
  const { state, setEmployeeCount } = props
  const calculator = calculatorText(i18next)
  return (
    <section className="block block--memberships-calc">
      <div className="block__inner container--m gutter--m spacing--m">
        <div className="block__layout container--s spacing--m gutter--m">
          <header className="block__header block__header--intro">
            <h2 className="block__title title--m">{calculator.title}</h2>
            <p className="block__intro text--l">{calculator.description}</p>
          </header>

          <div className="block__content membership-calculator mc">
            <div className="mc__group">
              <p className="mc__label text--l">
                {calculator.employeeCountQuestion}
              </p>

              <div className="mc__tabs mct">
                <div className="mct__tab">
                  <input
                    className="mct__input"
                    id="a11y-msc-t-1"
                    type="radio"
                    value="count_1"
                    checked={state.employeeCount == 'count_1'}
                    onChange={() => setEmployeeCount('count_1')}
                  />
                  <label className="mct__label" htmlFor="a11y-msc-t-1">
                    {employeeCount.get('count_1')?.label}
                  </label>
                </div>

                <div className="mct__tab">
                  <input
                    className="mct__input"
                    id="a11y-msc-t-2"
                    type="radio"
                    value="count_2"
                    checked={state.employeeCount == 'count_2'}
                    onChange={() => setEmployeeCount('count_2')}
                  />
                  <label className="mct__label" htmlFor="a11y-msc-t-2">
                    {employeeCount.get('count_2')?.label}
                  </label>
                </div>

                <div className="mct__tab">
                  <input
                    className="mct__input"
                    id="a11y-msc-t-3"
                    type="radio"
                    value="count_3"
                    checked={state.employeeCount == 'count_3'}
                    onChange={() => setEmployeeCount('count_3')}
                  />
                  <label className="mct__label" htmlFor="a11y-msc-t-3">
                    {employeeCount.get('count_3')?.label}
                  </label>
                </div>

                <div className="mct__tab">
                  <input
                    className="mct__input"
                    id="a11y-msc-t-4"
                    type="radio"
                    value="count_4"
                    checked={state.employeeCount == 'count_4'}
                    onChange={() => setEmployeeCount('count_4')}
                  />
                  <label className="mct__label" htmlFor="a11y-msc-t-4">
                    {employeeCount.get('count_4')?.label}
                  </label>
                </div>

                <div className="mct__tab">
                  <input
                    className="mct__input"
                    id="a11y-msc-t-5"
                    type="radio"
                    value="count_5"
                    checked={state.employeeCount == 'count_5'}
                    onChange={() => setEmployeeCount('count_5')}
                  />
                  <label className="mct__label" htmlFor="a11y-msc-t-5">
                    {employeeCount.get('count_5')?.label}
                  </label>
                </div>
              </div>
            </div>

            {state.employeeCount != '' && (
              <>
                <div className="mc__result">
                  <h3 className="block__title title--s">
                    {calculator.resultOfferTitle}
                  </h3>
                  <div className="text--styled">
                    <ul>
                      {(() => {
                        const perks = calculator.resultOfferPerks[state.employeeCount as keyof typeof calculator.resultOfferPerks]
                        const perksWithoutLast = perks.slice(0, -1)
                        const lastPerk = perks[perks.length - 1]

                        return (
                          // Key on employeeCount so React replaces the <li> elements instead of
                          // rewriting their text nodes: Google Translate detaches the original
                          // text nodes, so in-place text updates are not visible on translated pages.
                          <>
                            {perksWithoutLast.map((perk, idx) =>
                              <li key={`${state.employeeCount}-${idx}`}>{perk}</li>
                            )}
                            {lastPerk && (
                              <li key={`${state.employeeCount}-last`} className="mc__perk--last">
                                {/* Additional link for the last perk of the first item */}
                                {lastPerk} {state.employeeCount == 'count_1' && <Link url={calculator.internalActionLink}>{calculator.internalActionLabel}</Link> }
                              </li>
                            )}
                          </>
                        )
                      })()}
                    </ul>
                  </div>
                </div>

                <footer className="block__footer block__clickables">
                  <div className="block__clickable">
                    <ExternalLink
                      to={'https://c.spotler.com/ct/m13/k1/8GHkgTosFSOjGKKfxiMYHOfV_VwfYEgecNtqEabRq83lVIeGgj52-3_N6Php7J68nJozumsgWbXdryhYccyPe-1Q9AmV8gzJ3R9VzVY814k/TeaiPNESAZBhP2N'}
                      target="_blank"
                      className="button button--primary"
                    >
                      <span className="button__label">Word nu lid</span>
                    </ExternalLink>
                  </div>
                  <div className="block__clickable cta-phone">
                    <p className="cta-phone__title title--xs">
                      Of bel ons op:{' '}
                      <a
                        className="cta-phone__link"
                        href={`tel:${calculator.contactPhoneNr}`}
                      >
                        {calculator.contactPhoneNr}
                      </a>{' '}
                    </p>
                    <p className="cta-phone__text text--xs">
                      {calculator.contactPhoneText}
                    </p>
                  </div>
                </footer>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
